import { I18NItem } from '@src/types/common.type';

export const I18NList: I18NItem[] = [
  {
    key: 'en',
    value: 'ENG',
  },
  {
    key: 'zh',
    value: '中文',
  },
];

export const SET_GET_IN_TOUCH = 'SET_GET_IN_TOUCH';